import api from "@/api/v1-jwt/config/api";
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";
import clientSettingsQueryKeys from "./query-keys";
import {
  ClientSetting,
  SettingKey,
  SettingValueType,
  SettingCategory,
} from "./types";

export interface ClientSettingPayload {
  user_id: string;
  setting_id?: string;
  key: SettingKey;
  category: SettingCategory;
  value: any;
  value_type: SettingValueType;
  description: string;
  modified_by?: string;
  active: boolean;
}

interface CreateClientSettingsParams {
  settings: ClientSettingPayload[];
}

const createClientSettings = async ({
  settings,
}: CreateClientSettingsParams): Promise<ClientSetting[]> => {
  const url = `/platform/client-settings/`;
  const { data } = await api.post(url, settings);
  return data;
};

export const useCreateClientSettings = (
  options?: Omit<
    UseMutationOptions<ClientSetting[], Error, CreateClientSettingsParams>,
    "mutationFn"
  >
) => {
  const queryClient = useQueryClient();

  return useMutation<ClientSetting[], Error, CreateClientSettingsParams>({
    ...options,
    mutationFn: createClientSettings,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({
        queryKey: clientSettingsQueryKeys.all,
      });

      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
  });
};
